<template>
  <div>
    <!--EXTERNAL PICTURE-->
    <img
      v-if="isExternal"
      class="logo"
      :src="'data:image/jpeg;base64,' + presentedImage"
    />
    <!--UPLOAD BLOCK-->
    <form v-if="isInitial" enctype="multipart/form-data" novalidate>
      <div
        v-bind:class="{ dropbox: !isDisabled, 'dropbox-disabled': isDisabled }"
      >
        <input
          type="file"
          :name="uploadFieldName"
          :disabled="isDisabled"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          accept="image/*"
          class="input-file"
        />
        <p v-if="isInitial">
          Drag your file(s) here to begin<br />
          or click to browse
        </p>
        <!-- <p v-if="isSaving">Uploading {{ fileCount }} files...</p> -->
      </div>
    </form>
    <p v-if="isExternal || isSuccess || isFailed">
      <a href="javascript:void(0)" @click="reset()">Upload again</a>
    </p>
    <!--INTERNAL PICTURE-->
    <div v-if="isSuccess">
      <ul class="list-unstyled">
        <li v-for="(item, idx) in uploadedFiles" v-bind:key="idx">
          <img
            :src="item.url"
            class="img-responsive img-thumbnail"
            :alt="item.originalName"
          />
        </li>
      </ul>
    </div>
    <!--FAILED-->
    <div v-if="isFailed">
      <h2>Uploaded failed.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Try again</a>
      </p>
      <pre>{{ uploadError }}</pre>
    </div>
    <!--ADMINISTRATION BUTTONS - INVISIBLE FOR NOW-->
    <div class="columns" v-if="false">
      <!-- image manipulation buttons -->
      <div class="column">
        <button
          class="button"
          @click="copyWhiteButtonClicked"
          :disabled="copyWhiteButtonDisabled"
        >
          Copy white
        </button>
        <button
          class="button"
          @click="copyTransparentButtonClicked"
          :disabled="copyTransparentButtonDisabled"
        >
          Copy transparent
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const STATUS_INITIAL = 0,
  STATUS_EXTERNAL = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "ImageUploader",

  props: {
    isDisabled: Boolean,
    isImagePresented: Boolean,
    presentedImage: String,
    externalStatus: Number,
  },

  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      uploadButtonDisabled: false,
      copyWhiteButtonDisabled: true,
      copyTransparentButtonDisabled: true,
      image: null,
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isExternal() {
      return this.currentStatus === STATUS_EXTERNAL;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      // upload data to the server
      // this.currentStatus = STATUS_SAVING;

      this.upload(formData)
        .then((x) => {
          this.uploadedFiles = [].concat(x);
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    upload(formData) {
      const photos = formData.getAll("photos");
      const promises = photos.map((x) =>
        this.getImage(x).then((img) => ({
          id: img,
          originalName: x.name,
          fileName: x.name,
          url: img,
        }))
      );
      return Promise.all(promises);
    },
    getImage(file) {
      return new Promise((resolve) => {
        const fReader = new FileReader();
        const img = document.createElement("img");

        fReader.onload = () => {
          img.src = fReader.result;
          resolve(this.getBase64Image(img));
        };

        fReader.readAsDataURL(file);
      });
    },
    getBase64Image(img) {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const dataURL = img.src;
      console.log(dataURL);
      this.image = dataURL;
      var fullData = dataURL;
      var splittedData = fullData.split("base64,");
      this.$emit("imageChanged", splittedData[1]);

      return dataURL;
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      console.log("slika izgleda ovako:");
      console.log(fileList[0]);

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData);
    },
    copyWhiteButtonClicked() {
      alert("copyWhite");
    },
    copyTransparentButtonClicked() {
      alert("copyTransparent");
    },
  },
  mounted() {
    this.reset();
  },
  watch: {
    isImagePresented(val) {
      console.log(val);
      if (val === true) {
        this.currentStatus = STATUS_EXTERNAL;
        console.log(this.currentStatus);
      } else {
        this.currentStatus = STATUS_INITIAL;
        console.log(this.currentStatus);
      }
    },
    externalStatus(val) {
      console.log("external-status:");
      console.log(val);
      if (val === 0) {
        this.currentStatus = STATUS_INITIAL;
      } else if (val === 1) {
        this.currentStatus = STATUS_INITIAL;
      } else if (val === 2) {
        if (this.isImagePresented === true) {
          this.currentStatus = STATUS_EXTERNAL;
        } else {
          this.currentStatus = STATUS_INITIAL;
        }
      }
    },
  },
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.dropbox-disabled {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightgray;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.dropbox-disabled p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
